import {
    Alert,
    Button,
    Checkbox,
    Divider,
    Modal,
    Segmented,
    Space,
    Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import log from "cslog";
import TemplateAIInput, { DBInput } from "./TemplateAIInput";
import BookAI from "./BookAI";
import ColorAITest from "./ColorAITest";
import GSBox, { GSModal, ThemeFontsBox } from "./GSBox";
import { getPublicImageURL } from "../../_helpers/image";
import {
    BgColorsOutlined,
    BulbOutlined,
    FontSizeOutlined,
    Gra,
    ScheduleOutlined,
} from "@ant-design/icons";
import SocialPostingBox from "../../social_media/SocialPostingBox";
import { getEditURL } from "../../_helpers/editor";
import { applyOGColor } from "./processors/designs";
import { message } from "antd";
import CommentsBox from "./CommentsBox";
import LanguageDD from "./customizers/LanguageDD";
import styles from "./styles/DesignCustomization.module.css";
import { atom, useAtom } from "jotai";
import { getHeroIcon } from "../../_helpers/heroicons";

const applyThemeAtom = atom(false);

function DesignCustomization(props) {
    const { isMobile, platforms, entry_id, org_id } = props;

    const tabs = [
        {
            key: "content",
            label: "Compose",
            children: <ContentCustomization {...props} />,
            icon: getHeroIcon("sparkles", {
                width: "18px",
                marginBottom: "-5px",
            }),
        },
        {
            key: "theme",
            label: "Style",
            children: <ThemeCustomization {...props} />,
            icon: <BgColorsOutlined />,
        },
    ];

    if (isMobile) {
        tabs.push({
            key: "schedule",
            label: "Schedule",
            children: (
                <SocialPostingBox
                    platforms={platforms}
                    entry_id={entry_id}
                    org_id={org_id}
                />
            ),
            icon: <ScheduleOutlined />,
        });
    }

    return (
        <div style={{ paddingTop: isMobile ? 0 : "15px" }}>
            <Tabs type="line" items={tabs} />
        </div>
    );
}

export default DesignCustomization;

function ContentCustomization({
    db_inputs,
    item,
    me,
    isMobile,
    org,
    setOrg,
    person,
    setPerson,
    prefill,
    setPrefill,
    preset,
    gs_overrides,
    setGSOverrides,
    bookPrefill,
    setBookPrefill,
    loadingAIInput,
    user_inputs,
    tokenData,
    updateInputs,
    slug_field,
    is_template,
    setUserInputsFilled,
    lang: init_lang = "English",
    setLang = () => {},
    isTranslating = false,
    linkedPresetData,
}) {
    const lang = init_lang;
    const [commentsOpen, setCommentsOpen] = useState(false);

    log.d(item, "item in DCZ");
    const is_internal_user = ["designer", "reviewer"].includes(me?.irole);
    return (
        <div className={styles.wrapperContent}>
            <div>
                {!isMobile &&
                    is_internal_user &&
                    Object.keys(db_inputs).map((input_id) => {
                        const input = db_inputs[input_id];
                        return (
                            <>
                                <DBInput
                                    record_id={item?.id}
                                    input_id={input_id}
                                    input_data={input?.data}
                                    me={me}
                                    isMobile={isMobile}
                                    org={org}
                                    onOrgChange={(val) => setOrg(val)}
                                    onOrgChangeFull={(org_full) => {
                                        const brand_colors =
                                            org_full?.brand_colors || {};
                                        log.d(brand_colors, "brand_colors");
                                        setGSOverrides({
                                            config: brand_colors,
                                        });
                                    }}
                                    person={person}
                                    onPersonChange={(val) => setPerson(val)}
                                    prefill={prefill?.[input_id]}
                                    setPrefill={(new_values) => {
                                        setPrefill({
                                            ...prefill,
                                            [input_id]: new_values || {},
                                        });
                                    }}
                                    preset={preset}
                                />
                            </>
                        );
                    })}

                <LanguageDD
                    value={lang}
                    onChange={(val) => setLang(val)}
                    loading={isTranslating}
                    minimal
                />

                {item?.type === "flipbook" && (
                    <div>
                        <BookAI
                            item={item}
                            onBookGenerate={(val) => {
                                setBookPrefill(val);
                            }}
                        />
                    </div>
                )}
                {/* <p>item inputs is {JSON.stringify(item, null, 2)}</p> */}
                <TemplateAIInput
                    record_id={item?.id}
                    inputs={item.inputs}
                    used_schemas={item.used_schemas}
                    me={me}
                    org={org}
                    creation_type={item.type}
                    onOrgChange={(val) => setOrg(val)}
                    person={person}
                    onPersonChange={(val) => setPerson(val)}
                    isMobile={isMobile}
                    // loadingAI={mutationAIGen.isLoading || loadingAIInput}
                    loadingAI={loadingAIInput}
                    user_inputs={user_inputs}
                    lang={lang}
                    prefill={prefill}
                    setPrefill={setPrefill}
                    slug={item[slug_field]}
                    is_template={is_template}
                    onSubmitInputs={(data) => {
                        // if (tokenData?.[0]?.count < 2) {
                        //     console.log("token data", tokenData);
                        //     message.error(
                        //         "Not enough tokens to perform this generation"
                        //     );
                        //     return;
                        // }
                        updateInputs(data);
                        setUserInputsFilled(data);
                    }}
                    linkedPresetData={linkedPresetData}
                />
            </div>

            <div
            // className={styles.bottom_pane}
            >
                {/* {true && <CommentsBox creation={item} />} */}
                {/* <Button type="primary" onClick={() => setCommentsOpen(true)}>
                    Comments
                </Button> */}
            </div>

            <Modal
                open={commentsOpen}
                onCancel={() => setCommentsOpen(false)}
                footer={null}
                title="Comments"
                width={700}
            >
                {item?.id ? (
                    <CommentsBox template={item} />
                ) : (
                    <div>Loading...</div>
                )}
            </Modal>
        </div>
    );
}

function ThemeCustomization(props) {
    const [activeTab, setActiveTab] = useState("colors");
    return (
        <div>
            <Segmented
                block
                options={[
                    {
                        value: "colors",
                        label: "Colors",
                        icon: <BgColorsOutlined />,
                    },
                    {
                        value: "typography",
                        label: "Typography",
                        icon: <FontSizeOutlined />,
                    },
                ]}
                value={activeTab}
                onChange={setActiveTab}
                style={{ marginBottom: "12px" }}
            />
            {activeTab === "colors" ? (
                <ThemeColorCustomization {...props} />
            ) : (
                <ThemeTypographyCustomization {...props} />
            )}
        </div>
    );
}

function ThemeTypographyCustomization(props) {
    return (
        <div>
            <ThemeFontsBox
                config={props.gs_overrides?.config || {}}
                values={props.gs_overrides}
                onChange={(new_values) => {
                    props.setGSOverrides(new_values);
                    props.setColorTheme(new_values?.config?.theme);

                    const inverse_logo_theme = props?.item?.inverse_logo_theme;

                    const org_mod = getOrgMod(
                        props?.item?.theme,
                        new_values?.config?.theme,
                        props.me?.selected_org
                    );

                    log.d(org_mod, "org_mod");
                    props.setPrefill({
                        ...props.prefill,
                        current_organization: {
                            ...org_mod,
                        },
                    });
                }}
            />
        </div>
    );
}

function ThemeColorCustomization({
    item,
    me,
    isMobile,
    preset,
    one,
    updateOne,
    gs_values,
    gs_overrides,
    setGSOverrides,
    design_theme,
    color_theme,
    setColorTheme,
    prefill,
    setPrefill,
}) {
    const is_internal_user = ["designer", "reviewer"].includes(me?.irole);

    log.d(item, "item in TCC");

    return (
        <div>
            {is_internal_user && !item?.is_themeable && (
                <Alert
                    message="This design is not themeable"
                    // type="info"
                    type="warning"
                    // showIcon
                    action={
                        <Space>
                            <ColorAITest
                                item={item}
                                me={me}
                                isMobile={isMobile}
                                preset={preset}
                            />
                            <Button
                                onClick={() => {
                                    const url = getEditURL(item?.id);
                                    window.open(url, "_blank");
                                }}
                            >
                                Manually Edit
                            </Button>
                        </Space>
                    }
                    style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "10px",
                    }}
                ></Alert>
            )}

            {!is_internal_user && !item?.is_themeable && (
                <Alert message="This design is not themeable" type="info" />
            )}

            {(is_internal_user || item?.is_themeable) && (
                <GSBox
                    design_theme={item?.theme}
                    initial_values={gs_values}
                    values={gs_overrides}
                    onChange={(new_values) => {
                        setGSOverrides(new_values);
                        setColorTheme(new_values?.config?.theme);

                        // const inverse_logo_theme = item?.inverse_logo_theme;

                        log.d(new_values, "new_values in TCC");

                        const org_mod = item?.fixed_logo_theme
                            ? {}
                            : getOrgMod(
                                  item?.theme,
                                  new_values?.config?.theme,
                                  me?.selected_org
                              );

                        log.d(org_mod, "org_mod");
                        setPrefill({
                            ...prefill,
                            current_organization: {
                                ...org_mod,
                            },
                        });
                    }}
                    org={me?.selected_org}
                />
            )}

            {is_internal_user && one?.others?.ogColors && (
                <div
                    style={{
                        marginTop: "10px",
                    }}
                >
                    <Button
                        onClick={() => {
                            const newOne = applyOGColor(one);
                            if (newOne) {
                                updateOne(newOne);
                            }
                        }}
                        type="primary"
                    >
                        Restore Original Colors
                    </Button>
                </div>
            )}
        </div>
    );
}

function getOrgMod(design_theme, color_theme, selected_org) {
    const org_mod = {};
    if (design_theme && color_theme) {
        // if (design_theme === color_theme) {
        if (
            (["light", "force_light"].includes(design_theme) &&
                color_theme === "light") ||
            (["dark", "force_dark"].includes(design_theme) &&
                color_theme === "dark")
        ) {
            // same theme, don't do anything
        } else {
            org_mod["logo"] = getPublicImageURL(selected_org?.logo_dark);
            org_mod["logo_dark"] = getPublicImageURL(selected_org?.logo);
        }
    }
    return org_mod;
}

function getOrgModNew(inverse_logo_theme, color_theme, selected_org) {
    const org_mod = {};
    // logo bg is secondary
    if (inverse_logo_theme === true) {
        if (color_theme === "light") {
            org_mod["logo"] = getPublicImageURL(selected_org?.logo_dark);
            org_mod["logo_dark"] = getPublicImageURL(selected_org?.logo);
        } else {
            org_mod["logo"] = getPublicImageURL(selected_org?.logo);
            org_mod["logo_dark"] = getPublicImageURL(selected_org?.logo_dark);
        }
        // logo bg is primary
    } else if (inverse_logo_theme === false) {
        if (color_theme === "light") {
            org_mod["logo"] = getPublicImageURL(selected_org?.logo);
            org_mod["logo_dark"] = getPublicImageURL(selected_org?.logo_dark);
        } else {
            org_mod["logo"] = getPublicImageURL(selected_org?.logo_dark);
            org_mod["logo_dark"] = getPublicImageURL(selected_org?.logo);
        }
    }
    return org_mod;
}

export function AutoApplyTheme({
    gs_overrides,
    setGSOverrides,
    prefill,
    setPrefill,
    color_palettes,
    fixed_logo_theme,
    design_theme,
    org,
    isMobile,
}) {
    const [apply_theme, setApplyTheme] = useAtom(applyThemeAtom);

    useEffect(() => {
        if (!apply_theme) return;
        if (design_theme.includes("force") || design_theme === "na") {
            setGSOverrides({
                config: {},
            });
            return;
        }
        if (color_palettes?.length > 0) {
            const one = color_palettes[0];
            const new_values = {
                ...gs_overrides,
                config: {
                    ...one,
                },
            };
            log.d(new_values, "new_values in AAT");
            setGSOverrides(new_values);

            const org_mod = fixed_logo_theme
                ? {}
                : getOrgMod(design_theme, one?.theme, org);

            log.d(org_mod, "org_mod");
            setPrefill({
                ...prefill,
                current_organization: {
                    ...org_mod,
                },
            });
        }
    }, [color_palettes, design_theme, apply_theme]);
    log.d(color_palettes, "color_palettes in AAT");

    return (
        <Checkbox
            checked={apply_theme}
            onChange={(e) => {
                if (e.target.checked) {
                    setApplyTheme(true);
                } else {
                    setApplyTheme(false);
                    setGSOverrides({
                        config: {},
                    });
                }
            }}
            style={{
                alignItems: "center",
            }}
        >
            {isMobile ? "Theme" : "Apply Theme"}
        </Checkbox>
    );
}
